<!-- <section *ngIf="showButton"
  class="flex justify-end my-5 items-center p-4 border border-[#CCCCCC] rounded-[15px] shadow-[0_4px_6px_rgba(0,0,0,0.25)]">
  <ng-container *ngFor="let btn of buttons">
    <button *ngIf="btn.action === 3" type="button" (click)="fileInput.click()" [disabled]="btn.disabled??false"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]"
      [ngClass]="btn.bgColor">
      <img [src]="btn.icon" [alt]="btn.label" />
      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300 bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>

    <img *ngIf="btn.action === 12" (click)="onClick(btn.action)" [src]="btn.icon" [alt]="btn.label"
      class="cursor-pointer group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]" />
    <span
      class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300 bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
      {{ btn.label }}
    </span>

    <button *ngIf="btn.action == 5" [disabled]="btn.status == '0'" (click)="onClick(btn.action)"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem] rounded-xl transition"
      [ngClass]="[
            btn.bgColor,
            btn.status == '0' ? 'opacity-50 cursor-not-allowed saturate-0' : 'hover:opacity-90'
        ]">

      <img [src]="btn.icon" [alt]="btn.label" />

      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300 bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>

    </button>

    <button *ngIf="btn.action !== 5 && btn.action !== 3 && btn.action !== 12" (click)="onClick(btn.action)"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]"
      [ngClass]="btn.bgColor" [disabled]="btn.disabled??false">
      <img [ngStyle]="btn.action === 100 ? { width: '68%' } : {}" [src]="btn.icon" [alt]="btn.label" />
      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300 bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>


  </ng-container>

  <input #fileInput type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" hidden />
</section> -->

<section *ngIf="showButton"
  class="flex justify-end my-5 items-center p-4 border border-[#CCCCCC] rounded-[15px] shadow-[0_4px_6px_rgba(0,0,0,0.25)]">

  <ng-container *ngFor="let btn of buttons">

    <!-- BOTÓN CARGAR (action === 3) -->
    <button *ngIf="btn.action === 3"
      type="button"
      (click)="fileInput.click()"
      [disabled]="btn.disabled ?? false"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]"
      [ngClass]="btn.bgColor">

      <!-- ICONO -->
      <ng-container *ngIf="btn.materialIcon; else cargarImg">
        <span translate="no" class="material-symbols-outlined text-white text-[22px]">
          {{ btn.materialIcon }}
        </span>
      </ng-container>

      <ng-template #cargarImg>
        <img [src]="btn.icon" [alt]="btn.label" />
      </ng-template>

      <!-- TOOLTIP -->
      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300
               bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>

    <!-- BOTÓN ICONO CLICK (action === 12) -->
    <button *ngIf="btn.action === 12"
      (click)="onClick(btn.action)"
      class="cursor-pointer group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]"
      [ngClass]="btn.bgColor">

      <ng-container *ngIf="btn.materialIcon; else iconImg12">
        <span translate="no" class="material-symbols-outlined text-white text-[22px]">
          {{ btn.materialIcon }}
        </span>
      </ng-container>

      <ng-template #iconImg12>
        <img [src]="btn.icon" [alt]="btn.label" />
      </ng-template>

      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300
               bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>

    <!-- BOTÓN STATUS (action === 5) -->
    <button *ngIf="btn.action === 5"
      [disabled]="btn.status === '0'"
      (click)="onClick(btn.action)"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px]
             w-[60px] mx-[0.5rem] rounded-xl transition"
      [ngClass]="[
        btn.bgColor,
        btn.status === '0'
          ? 'opacity-50 cursor-not-allowed saturate-0'
          : 'hover:opacity-90'
      ]">

      <ng-container *ngIf="btn.materialIcon; else iconImg5">
        <span translate="no" class="material-symbols-outlined text-white text-[22px]">
          {{ btn.materialIcon }}
        </span>
      </ng-container>

      <ng-template #iconImg5>
        <img [src]="btn.icon" [alt]="btn.label" />
      </ng-template>

      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300
               bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>

    <!-- OTROS BOTONES -->
    <button *ngIf="btn.action !== 5 && btn.action !== 3 && btn.action !== 12"
      (click)="onClick(btn.action)"
      [disabled]="btn.disabled ?? false"
      class="group relative flex flex-col items-center justify-center py-3 px-2 text-[10px] w-[60px] mx-[0.5rem]"
      [ngClass]="btn.bgColor">

      <ng-container *ngIf="btn.materialIcon; else iconImg">
        <span translate="no" class="material-symbols-outlined text-white text-[22px]">
          {{ btn.materialIcon }}
        </span>
      </ng-container>

      <ng-template #iconImg>
        <img
          [ngStyle]="btn.action === 100 ? { width: '68%' } : {}"
          [src]="btn.icon"
          [alt]="btn.label" />
      </ng-template>

      <span
        class="absolute bottom-[-2rem] scale-0 group-hover:scale-100 transition-all duration-300
               bg-black text-white text-[10px] px-2 py-1 rounded-md pointer-events-none whitespace-nowrap z-10">
        {{ btn.label }}
      </span>
    </button>

  </ng-container>

  <!-- INPUT OCULTO -->
  <input #fileInput
    type="file"
    (change)="onFileChange($event)"
    accept=".xlsx, .xls"
    hidden />
</section>
